import { render, staticRenderFns } from "./ViewAttendance.vue?vue&type=template&id=6495afdc&scoped=true&"
import script from "./ViewAttendance.vue?vue&type=script&lang=js&"
export * from "./ViewAttendance.vue?vue&type=script&lang=js&"
import style0 from "./ViewAttendance.vue?vue&type=style&index=0&id=6495afdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6495afdc",
  null
  
)

export default component.exports